import cn from 'classnames';

interface Props {
  progressPercentage: number;
  isDark?: boolean;
  isVeev?: boolean;
  className?: string;
  currentPrimaryColor: string;
  isLayoutRightToLeft?: boolean;
}

export const ProgressBar = ({
  isLayoutRightToLeft,
  currentPrimaryColor,
  isDark = false,
  progressPercentage,
  className,
}: Props) => {
  const progressSliderStyle = {
    backgroundColor: isDark ? '#34303d' : currentPrimaryColor,
    width: `${progressPercentage}%`,
  };

  return (
    <div className={cn('ta-v2-progress-bar-cover', className)}>
      <div
        style={progressSliderStyle}
        className={cn('ta-v2-progress-bar-slider', {
          'full-progress': progressPercentage >= 100,
          isLayoutRightToLeft,
        })}
      />
    </div>
  );
};
